// aiConstants.js
// Wire values remain orbital_ai / conv_ai_* until an explicit persistence phase.

export const AI_CONVERSATION_KIND = 'orbital_ai';
export const AI_TITLE = 'Appdeck';
/** Feed session title — proactive inbox (briefings, digests, watches, social). */
export const AI_UPDATES_TITLE = 'AI Updates';
export const AI_NEW_CHAT_TITLE = 'New session';
export const AI_AUTHOR_KEY = 'orbital_ai';

/** Legacy Feed titles we rewrite to AI Updates when titleSource is system. */
export const AI_LEGACY_FEED_TITLES = Object.freeze([
  'orbital ai',
  'ask orbital',
  'ask orbital ai',
]);

export const AI_SESSION_KINDS = Object.freeze({
  FEED: 'feed',
  CHAT: 'chat',
});

export const AI_TITLE_SOURCES = Object.freeze({
  SYSTEM: 'system',
  AUTO: 'auto',
  USER: 'user',
});

export const MESSAGE_TYPES = Object.freeze({
  USER_TEXT: 'user_text',
  AI_TEXT: 'ai_text',
  AI_SURFACE: 'ai_surface',
  AI_FEED_ITEM: 'ai_feed_item',
});
